import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _dec, _class, _class2, _temp;

import React from 'react';
import { locale } from "../../../lib/locale/decorators";
import { CrossIcon } from "../../../internal/icons/CrossIcon";
import { emptyHandler } from "../../../lib/utils";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { rootNode } from "../../../lib/rootNode";
import { isTheme2022 } from "../../../lib/theming/ThemeHelpers";
import { CloseButtonIcon } from "../../../internal/CloseButtonIcon/CloseButtonIcon";
import { reactGetTextContent } from "../../../lib/reactGetTextContent";
import { getVisualStateDataAttributes } from "../../../internal/CommonWrapper/utils/getVisualStateDataAttributes";
import { styles, colorStyles } from "../Token.styles";
import { TokenLocaleHelper } from "../locale";
import { TokenView } from "../TokenView";

var getValidation = function getValidation(error, warning) {
  if (error) {
    return 'error';
  } else if (warning) {
    return 'warning';
  }

  return null;
};

export var TokenDataTids = {
  root: 'Token__root',
  removeIcon: 'Token__removeIcon'
};
export var Token = (_dec = locale('Token', TokenLocaleHelper), rootNode(_class = _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Token, _React$Component);

  function Token() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onRemoveClick = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          _this$props$onRemove = _this$props.onRemove,
          onRemove = _this$props$onRemove === void 0 ? emptyHandler : _this$props$onRemove;

      if (disabled) {
        event.preventDefault();
        return;
      }

      onRemove(event);
    };

    return _this;
  }

  var _proto = Token.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _this$props2 = this.props,
        size = _this$props2.size,
        children = _this$props2.children,
        isActive = _this$props2.isActive,
        _this$props2$colors = _this$props2.colors,
        colors = _this$props2$colors === void 0 ? {
      idle: 'defaultIdle',
      active: 'defaultActive'
    } : _this$props2$colors,
        error = _this$props2.error,
        warning = _this$props2.warning,
        disabled = _this$props2.disabled,
        ariaDescribedby = _this$props2['aria-describedby'],
        _this$props2$onClick = _this$props2.onClick,
        onClick = _this$props2$onClick === void 0 ? emptyHandler : _this$props2$onClick,
        _this$props2$onDouble = _this$props2.onDoubleClick,
        onDoubleClick = _this$props2$onDouble === void 0 ? emptyHandler : _this$props2$onDouble,
        _this$props2$onMouseE = _this$props2.onMouseEnter,
        onMouseEnter = _this$props2$onMouseE === void 0 ? emptyHandler : _this$props2$onMouseE,
        _this$props2$onMouseL = _this$props2.onMouseLeave,
        onMouseLeave = _this$props2$onMouseL === void 0 ? emptyHandler : _this$props2$onMouseL,
        _this$props2$onFocus = _this$props2.onFocus,
        onFocus = _this$props2$onFocus === void 0 ? emptyHandler : _this$props2$onFocus,
        _this$props2$onBlur = _this$props2.onBlur,
        onBlur = _this$props2$onBlur === void 0 ? emptyHandler : _this$props2$onBlur;
    var theme = this.theme;
    var validation = getValidation(error, warning);
    var removeButtonAriaLabel = this.locale.removeButtonAriaLabel + ' ' + reactGetTextContent(children);
    var icon = isTheme2022(theme) ? /*#__PURE__*/React.createElement(CloseButtonIcon, {
      side: 16,
      color: "inherit",
      colorHover: "inherit",
      "aria-label": removeButtonAriaLabel,
      tabbable: false
    }) : /*#__PURE__*/React.createElement(CrossIcon, null);
    var classNames = isTheme2022(theme) ? cx(styles.tokenDefaultIdle2022(theme), !isActive && !warning && !error && !disabled && styles.tokenDefaultIdleHovering2022(theme), isActive && styles.tokenDefaultActive2022(theme), warning && styles.tokenWarning2022(theme), error && styles.tokenError2022(theme), disabled && styles.tokenDisabled2022(theme)) : cx(colorStyles[colors.idle](theme, validation), !!isActive && colorStyles[colors.active || colors.idle](theme, validation), !!disabled && styles.disabled(theme), !!disabled && colorStyles.defaultDisabled(theme), !!disabled && warning && colorStyles.defaultDisabledWarning(theme), !!disabled && error && colorStyles.defaultDisabledError(theme));
    var textholder = /*#__PURE__*/React.createElement("span", {
      className: styles.text(this.theme)
    }, children);
    var closeButton = /*#__PURE__*/React.createElement("span", {
      role: isTheme2022(theme) ? undefined : 'button',
      "aria-label": isTheme2022(theme) ? undefined : removeButtonAriaLabel,
      onClick: this.onRemoveClick,
      "data-tid": TokenDataTids.removeIcon
    }, icon);
    return /*#__PURE__*/React.createElement(CommonWrapper, _extends({
      rootNodeRef: this.setRootNode
    }, this.props, getVisualStateDataAttributes({
      disabled: disabled
    })), /*#__PURE__*/React.createElement(TokenView, {
      className: classNames,
      size: size,
      closeButton: closeButton,
      "data-tid": TokenDataTids.root,
      "aria-describedby": ariaDescribedby,
      onClick: onClick,
      onDoubleClick: onDoubleClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onFocus: onFocus,
      onBlur: onBlur
    }, textholder));
  };

  return Token;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Token', _class2.displayName = 'Token', _temp)) || _class) || _class);